export default __webpack_public_path__ + "media/images/images_v2/btnvalider-e157884e841314dd65fdd38f57af4c15.png";